/**
 * Unified time utilities for time calculations
 */

/**
 * Parse time string (HH:MM) to minutes since midnight
 */
export function parseTimeToMinutes(time: string): number {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
}

/**
 * Format minutes from midnight to HH:MM string
 */
export function formatMinutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
}

/**
 * Get current time in minutes from midnight
 */
export function getCurrentMinutes(now: Date = new Date()): number {
  return now.getHours() * 60 + now.getMinutes();
}
